import { ListDeviceStatesResponse } from '@wavingroup/iot-core/gen/ts/wavin/blaze/v1/blaze_device_service_pb';
import { DeviceStateModel } from '~/shared/models/deviceState/DeviceStateModel';

export class DeviceStatesListModel {
  readonly deviceStates: DeviceStateModel[];

  constructor(listDeviceStatesResponse: ListDeviceStatesResponse) {
    this.deviceStates = listDeviceStatesResponse.deviceStates.map(
      (deviceState) => new DeviceStateModel(deviceState),
    );
  }
}
